<template>
  <div class="text-left">
    <h3 class="text-l">Beat as many Syndles to score the maximum points!</h3>

    <ul class="list-disc list-inside mt-2">
      <li>A Syndle contains <b>3</b> words you need to guess</li>
      <li>All words in a Syndle are synonyms*, so crack one and the rest mean the same</li>
      <li>Tap letters to reveal them: a wrong letter costs a <b>heart</b></li>
      <li>Sure of a word? Type it in and guess: right banks a <b>heart</b>, wrong loses <b>two</b> (a word with only its last letter hidden is already as good as solved, so it won't earn one)</li>
      <li>You get <b>1</b> go per day</li>
    </ul>
    <p class="mt-4">*A synonym is a word or phrase that means exactly or nearly the same as another word or phrase in the same language, for example shut is a synonym of close.</p>

    <br>
    <h3><strong>Hearts</strong> - You start the day with <b>6</b> hearts and can build up to <b>8</b>. They carry across every puzzle in the day, and you gain one each time you solve a Syndle. Run out and your day is over: hearts refill tomorrow.</h3>

    <br>
    <h3><strong>Level Up</strong> - Gain XP for every Syndle you solve, the further you get the more XP and gain even more if you're logged in!</h3>
  </div>
</template>
<script setup>

defineProps({
  score: Number,
})
</script>


<style scoped>

</style>